export default __webpack_public_path__ + "static/media/cl01.39a1a402.jpg";